<template>
    <div>
        <!-- banner -->
        <Banner></Banner>
        <!-- 通知公告 -->
        <!--<Notice></Notice>-->
        <!-- 成立工作室流程 -->
        <!--<Flow></Flow>-->
        <!-- 工作室介绍 -->
        <Introduce></Introduce>
        <!-- 优质工作室 -->
        <QualityStudio></QualityStudio>
        <!-- 工作室优秀项目 -->
        <QualityProject></QualityProject>
    </div>
</template>
<script>
    // new Tab('#gzsjs .hds li','#gzsjs .bds > div',1,"click",1000);
    import {Banner, Flow, Introduce, QualityStudio, QualityProject} from './components';
    import {Notice} from '@/pages/frontend/components';

    export default {
        data() {
            return {
                noticeList: [{
                    name: '数据智能服务平台即将推出重大改版内容1'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容2'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容3'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容4'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容5'
                }]
            }
        },
        components: {
            Banner,
            Notice,
            Flow,
            Introduce,
            QualityStudio,
            QualityProject
        }
    }
</script>
<style scoped>
    @import "~@/pages/frontend/assets/css/workroom.css";
</style>